import React, { Suspense } from 'react'
import { Switch, Route } from 'react-router'
import { GenericPageHeaderSkeleton } from '../../../legacy-components/page-headers/GenericPageHeader';
import { ThemeProvider } from '@material-ui/core';
import { theme } from 'themes/mui';
import ApplicationSummaryPage from './pages/application-summary-page/ApplicationSummaryPage';
import { ApiDiscoveryPage } from './pages/ApiDiscovery';



interface IdentityApplicationRouteProps {

}


function ApisRoutes(props: IdentityApplicationRouteProps) {
    return (
        <ThemeProvider theme={theme}>
        <Suspense fallback={<GenericPageHeaderSkeleton />}>
            <Switch>
                <Route exact path="/home/apis" render={() => ( <ApiDiscoveryPage/>)} />

                <Route path="/home/apis/list" render={() => (
                   <ApiDiscoveryPage/>
                )} />

                <Route exact path="/home/apis/:id/gateway/:environmentName/summary" render={(routeProps) => (
                    <ApplicationSummaryPage/>
                )} />



               

            </Switch>
        </Suspense>
        </ThemeProvider>
    )
}

ApisRoutes.propTypes = {

}

export default ApisRoutes

